import React, { useEffect } from "react";
import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import { useMst } from "../../store/root";
import styles from "./Modal.module.scss";
import { ModalButton, TextButton } from "../baseComponents";
import { postToServer } from "../../store/utils/postToServer";
import { getVersion } from "../../jsxProviders/helpers/tmpDir";
export const NewerVersionModal = observer(() => {
  const {
    uiStore: {
      newerVersionModalType,
      setNewerVersionModalHidden,
      newerVersionLink,
      newerVersionNumber,
      newerUiVersionNumber,
    },
  } = useMst();
  const [isMajor, setIsMajor] = React.useState<boolean>(false);
  useEffect(() => {
    const runAsync = async () => {
      const isMajor = (jsxVersion: string) => {
        const latestVersion =
          newerVersionModalType === "main"
            ? newerVersionNumber
            : newerUiVersionNumber;
        const currentVersion =
          newerVersionModalType === "main"
            ? jsxVersion
            : (process.env.REACT_APP_VERSION as string);
        const latestArray = latestVersion.split(/-|\./);
        const currentArray = currentVersion.split(/-|\./);
        if (
          latestArray?.length > 0 &&
          currentArray?.length > 0 &&
          !isNaN(parseInt(latestArray[0])) &&
          !isNaN(parseInt(currentArray[0]))
        ) {
          if (latestArray[0] > currentArray[0]) {
            return true;
          }
        }
        return false;
      };
      try {
        const jsxVersion = await getVersion();
        setIsMajor(isMajor(jsxVersion));
      } catch (e) {
        console.error(e);
      }
    };
    runAsync();
  }, [newerVersionNumber, newerUiVersionNumber, newerVersionModalType]);
  return (
    <Modal
      className={styles.Modal}
      visible={!!newerVersionModalType}
      onOk={() => setNewerVersionModalHidden}
      {...(!isMajor && { onCancel: setNewerVersionModalHidden })}
      {...(isMajor && { closable: false, maskClosable: false })}
      footer={false}
    >
      <h1>New {isMajor ? "major" : ""} Version!</h1>
      <span>
        <p className={styles.AlertMessage}>
          {`Version ${
            newerVersionModalType === "main"
              ? newerVersionNumber
              : 'Update'
          } is out,\n ${
            isMajor
              ? "An update is required to continue using the Extension."
              : "we highly recommend upgrading."
          } \n`}
        </p>
        {newerVersionModalType === "ui" ? (
          <p className={styles.Restart}>Please restart Adobe AE</p>
        ) : null}
      </span>
      <div className={styles.Buttons}>
        {!isMajor && !(newerVersionModalType === "ui") && (
          <TextButton onClick={setNewerVersionModalHidden} text="Ignore" />
        )}
        {newerVersionModalType === "main" ? (
          <ModalButton
            onClick={() => {
              postToServer("openUrl", {
                url: newerVersionLink,
              });
              !isMajor && setNewerVersionModalHidden();
            }}
            text="Download now"
          />
        ) : null}
      </div>
    </Modal>
  );
});
